<template>
  <!-- 父类盒子需要设置 position: relative -->
  <!-- 策划与美术确认过，前端写死，后面再调整需求，样式也是临时写死 -->
  <div :class="typeLocation == 'top' ? 'interest-view-top ' : 'interest-view-bottom'">
    <div
      class="chxy-row-ac"
      :class="typeLocation == 'top' ? 'interest-top-tag' : 'interest-bottom-tag'"
    >
      <img :src="getImageUrlWithCDN_LOCAL('/home2/qiandai2.webp')" />

      <span>$+11~1888</span>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  // describe: { type: String, default: '-' },
  typeLocation: { type: String, default: 'top' },
})
</script>

<style lang="less" scoped>
.interest-view-top {
  position: absolute;
  left: -8px;
  top: 25px;
}

.interest-view-bottom {
  position: absolute;
  left: 45px;
  top: -16px;
}

.interest-top-tag {
  border-radius: 5px;
  font-size: 10px;
  height: 22px;
  background: #fed656;
  border: 1px solid #fff99f;
  width: 86px;
  font-weight: 600;
  font-family: Roboto, Roboto;
  font-size: 11px;
  color: #813b35;

  img {
    width: 22px;
    height: 28px;
    margin-bottom: 15px;
  }

  /* 顶部中间的下箭头 */
  &::after {
    content: '';
    position: absolute;
    top: -5px; /* 向上超出标签边界 */
    left: 50%; /* 水平居中 */
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5.5px solid transparent;
    border-right: 5.5px solid transparent;
    border-bottom: 6px solid #fed656; /* 向下箭头，颜色与背景一致 */
  }
}

.interest-bottom-tag {
  border-radius: 5px;
  font-size: 10px;
  height: 22px;
  background: #fed656;
  border: 1px solid #fff99f;
  width: 86px;
  font-weight: 600;
  font-family: Roboto, Roboto;
  font-size: 11px;
  color: #813b35;

  img {
    width: 22px;
    height: 28px;
    margin-bottom: 15px;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -5px; /* 改为底部，负值使其超出边界 */
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5.5px solid transparent;
    border-right: 5.5px solid transparent;
    border-top: 6px solid #fed656; /* 改为 border-top，箭头朝上 */
  }
}
</style>
